import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ReportsLayout from './reports/ReportsLayout'

// Import all report pages
import OverviewReport from './reports/overview'
import FacebookReport from './reports/facebook'
import GoogleReport from './reports/google'
import ChartsReport from './reports/charts'
import SchoolSummaryReport from './reports/school-summary'
import ClientReportsReport from './reports/client-reports'
import FbAdsReport from './reports/fb-ads'
import MasterReport from './reports/master-report'
import VisibilityReport from './reports/visibility-report'
import AdLevelReport from './reports/ad-level-report'

const Reports: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ReportsLayout />}>
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<OverviewReport />} />
        <Route path="facebook" element={<FacebookReport />} />
        <Route path="google" element={<GoogleReport />} />
        <Route path="charts" element={<ChartsReport />} />
        <Route path="school-summary" element={<SchoolSummaryReport />} />
        <Route path="client-reports" element={<ClientReportsReport />} />
        <Route path="fb-ads" element={<FbAdsReport />} />
        <Route path="visibility-report" element={<VisibilityReport />} />
        <Route path="master-report" element={<MasterReport />} />
        <Route path="ad-level-report" element={<AdLevelReport />} />
      </Route>
    </Routes>
  )
}

export default Reports
